var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import widgetsDictionary from "../../widgetsDictionary";
import { useEffect, useRef, useState } from "react";
import { useGetAdminMenuQuery } from "@/store/api";
import { faGear, faUsers } from "@fortawesome/pro-regular-svg-icons";
import { faKey, faLockKeyhole, faShieldKeyhole, faCircleEuro, faLanguage, faGlobeAmericas, faFilePdf, faSearch, faClock, faClockDesk, faSwatchbook, faSquareList, faCircle, faAdd, faList, faCalendar, faDownload, faWrench, faEye, faRefresh, faChevronRight, faHome, } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppDispatch, useAppSelector } from "@/hooks/store";
import { setMenuAdmin, setSelectedMenu } from "@/store/administrationSlice";
import { createPortal } from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { LoaderImage } from "@/utils/loader";
export default function AdminWidgetHorizontal() {
    var _a;
    var location = useLocation();
    var _b = useGetAdminMenuQuery({}), dataMenu = _b.data, isLoading = _b.isLoading;
    var dispatch = useAppDispatch();
    var selectedMenu = useAppSelector(function (state) { return state.adminMenu.selected_menu; });
    var menuList = useAppSelector(function (state) { return state.adminMenu.menu_admin; });
    useEffect(function () {
        if (!dataMenu)
            return;
        var menuAdmindata = dataMenu.data.map(function (group, index) { return (__assign(__assign({}, group), { _groupIndex: index })); });
        dispatch(setMenuAdmin(menuAdmindata));
    }, [dataMenu]);
    var getFontAwesomeIcon = function (icon) {
        var fontAwesomeIcon = faGear;
        switch (icon) {
            case "supervised_user_circle":
                fontAwesomeIcon = faUsers;
                break;
            case "vpn_key":
                fontAwesomeIcon = faLockKeyhole;
                break;
            case "security":
                fontAwesomeIcon = faShieldKeyhole;
                break;
            case "oauth":
                fontAwesomeIcon = faKey;
                break;
            case "monetization_on":
                fontAwesomeIcon = faCircleEuro;
                break;
            case "language":
                fontAwesomeIcon = faLanguage;
                break;
            case "locale":
                fontAwesomeIcon = faGlobeAmericas;
                break;
            case "pdf-settings":
                fontAwesomeIcon = faFilePdf;
                break;
            case "search":
                fontAwesomeIcon = faSearch;
                break;
            case "schedule":
                fontAwesomeIcon = faClockDesk;
                break;
            case "theme":
                fontAwesomeIcon = faSwatchbook;
                break;
            case "aobh-businesshours":
                fontAwesomeIcon = faClock;
                break;
            case "modules-and-subpanels":
            case "module-menu-filters":
                fontAwesomeIcon = faSquareList;
                break;
            case "title":
                fontAwesomeIcon = faCircle;
                break;
            case "add":
                fontAwesomeIcon = faAdd;
                break;
            case "list":
                fontAwesomeIcon = faList;
                break;
            case "schedule":
                fontAwesomeIcon = faCalendar;
                break;
            case "import":
                fontAwesomeIcon = faDownload;
                break;
            case "config":
                fontAwesomeIcon = faWrench;
                break;
            case "view":
                fontAwesomeIcon = faEye;
                break;
            case "refresh":
                fontAwesomeIcon = faRefresh;
                break;
            case "home":
                fontAwesomeIcon = faHome;
                break;
            default:
                fontAwesomeIcon = faGear;
                break;
        }
        return fontAwesomeIcon;
    };
    var _c = useState(null), openGroup = _c[0], setOpenGroup = _c[1];
    var _d = useState(null), openSub = _d[0], setOpenSub = _d[1];
    var _e = useState(null), groupRect = _e[0], setGroupRect = _e[1];
    var _f = useState(null), subRect = _f[0], setSubRect = _f[1];
    var hoverTimeout = useRef(null);
    var groupRefs = useRef([]);
    var subRefs = useRef([]);
    var navigate = useNavigate();
    var clearHoverTimeout = function () {
        if (hoverTimeout.current) {
            window.clearTimeout(hoverTimeout.current);
            hoverTimeout.current = null;
        }
    };
    //Gestion de l'élément du fil d'ariane
    var buildBreadcrumbPath = function (group, item, child) {
        var path = [];
        path.push({
            title: "",
            desc: "",
            url: "/modules/Administration",
            icon: "home",
            _groupIndex: null,
        });
        // 1. Premier niveau
        path.push({
            title: group.title,
            desc: group.desc || "",
            url: null,
            icon: group.icon || "",
            _groupIndex: group._groupIndex, //indice de bloc
        });
        // 2. deuxième niveau (si il existe)
        if (item) {
            path.push({
                title: item.label,
                desc: item.desc || "",
                url: item.url || "",
                icon: item.icon,
            });
        }
        // 3. troisième niveau (child)
        if (child) {
            path.push({
                title: child.label,
                desc: child.desc || "",
                url: child.url || "",
                icon: child.icon,
            });
        }
        return path;
    };
    //Restauration de la dernière page consultée
    useEffect(function () {
        if (!menuList)
            return;
        if (!selectedMenu || selectedMenu.length === 0)
            return;
        var last = selectedMenu[selectedMenu.length - 1];
        if (location.pathname === "/modules/Administration" &&
            last.url &&
            typeof last.url === "string") {
            navigate(last.url);
        }
    }, [menuList]);
    var lastDesc = (selectedMenu && ((_a = selectedMenu[selectedMenu.length - 1]) === null || _a === void 0 ? void 0 : _a.desc)) || "";
    return (_jsxs("div", __assign({ className: "w-full space-y-2 bg-[var(--colors-widget)]" }, { children: [_jsxs("div", __assign({ className: "flex flex-wrap gap-4 items-center rounded-xl py-1 px-4" }, { children: [(!menuList || menuList.length === 0) && _jsx(LoaderImage, {}), menuList &&
                        (menuList === null || menuList === void 0 ? void 0 : menuList.map(function (group, gIndex) { return (_jsx("div", __assign({ ref: function (el) { return (groupRefs.current[gIndex] = el); }, onMouseEnter: function () {
                                var _a;
                                clearHoverTimeout();
                                setOpenGroup(gIndex);
                                var rect = (_a = groupRefs.current[gIndex]) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                                setGroupRect(rect || null);
                                setOpenSub(null);
                            }, onMouseLeave: function () {
                                hoverTimeout.current = window.setTimeout(function () {
                                    setOpenGroup(null);
                                    setOpenSub(null);
                                }, 150);
                            }, className: "relative cursor-pointer uppercase font-medium" }, { children: group.title }), gIndex)); }))] })), openGroup !== null &&
                groupRect &&
                menuList &&
                menuList[openGroup] &&
                createPortal(_jsx("div", __assign({ className: "bg-white shadow-lg rounded z-[9999] mt-4 cursor-pointer", style: {
                        position: "fixed",
                        top: groupRect.bottom,
                        left: groupRect.left,
                        minWidth: groupRect.width,
                    }, onMouseEnter: clearHoverTimeout, onMouseLeave: function () {
                        hoverTimeout.current = window.setTimeout(function () {
                            setOpenGroup(null);
                            setOpenSub(null);
                        }, 150);
                    } }, { children: menuList[openGroup].items.map(function (item, idx) {
                        var _a;
                        var children = Array.isArray((_a = item.children) === null || _a === void 0 ? void 0 : _a.items)
                            ? item.children.items
                            : Array.isArray(item.children)
                                ? item.children
                                : [];
                        return (_jsxs("div", __assign({ ref: function (el) { return (subRefs.current[idx] = el); }, onMouseEnter: function () {
                                var _a;
                                clearHoverTimeout();
                                setOpenSub(idx);
                                var rect = (_a = subRefs.current[idx]) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                                setSubRect(rect || null);
                            }, onMouseLeave: function () {
                                hoverTimeout.current = window.setTimeout(function () {
                                    setOpenSub(null);
                                }, 150);
                            }, className: "flex justify-between relative  px-4 py-2 hover:bg-gray-100 whitespace-nowrap", onClick: function (e) {
                                e.stopPropagation();
                                navigate(item.url);
                                var path = buildBreadcrumbPath(menuList[openGroup], item);
                                dispatch(setSelectedMenu(path));
                            } }, { children: [_jsxs("div", __assign({ className: "items-start" }, { children: [item.icon && (_jsx(FontAwesomeIcon, { icon: getFontAwesomeIcon(item.icon), className: "mr-2" })), _jsx("span", { children: item.label })] })), _jsx("div", __assign({ className: "items-end" }, { children: children.length > 0 && (_jsx("span", __assign({ className: "items-end" }, { children: "\u203A" }))) })), children.length > 0 &&
                                    openSub === idx &&
                                    subRect &&
                                    createPortal(_jsx("div", __assign({ className: "bg-white shadow-lg rounded z-[10000] py-2 min-w-[180px] cursor-pointer", style: {
                                            position: "fixed",
                                            top: subRect.top,
                                            left: subRect.right,
                                        }, onMouseEnter: clearHoverTimeout, onMouseLeave: function () {
                                            hoverTimeout.current = window.setTimeout(function () {
                                                setOpenSub(null);
                                            }, 150);
                                        } }, { children: children.map(function (child, cIndex) { return (_jsxs("div", __assign({ className: "px-4 py-2 whitespace-nowrap hover:bg-gray-100", onClick: function (e) {
                                                e.stopPropagation();
                                                navigate(child.url);
                                                var path = buildBreadcrumbPath(menuList[openGroup], item, child);
                                                dispatch(setSelectedMenu(path));
                                            } }, { children: [_jsx(FontAwesomeIcon, { icon: getFontAwesomeIcon(child.icon), className: "mr-2" }), _jsx("span", { children: child.label })] }))); }) })), document.body)] }), idx));
                    }) })), document.body), _jsx("div", __assign({ className: "flex min-h-0 h-auto m-2" }, { children: selectedMenu &&
                    (selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.map(function (item, index) {
                        var isLast = index === selectedMenu.length - 1;
                        return (_jsxs("div", __assign({ className: "flex items-center" }, { children: [_jsxs("div", __assign({ onClick: function () {
                                        if (index === 0 && item.icon === "home") {
                                            dispatch(setSelectedMenu([]));
                                            navigate("/modules/Administration");
                                            return;
                                        }
                                        //ne rien faire si menuList pas prêt
                                        if (!menuList || menuList.length === 0)
                                            return;
                                        if (!item.url)
                                            return;
                                        var cut = selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.slice(0, index + 1);
                                        dispatch(setSelectedMenu(cut));
                                        navigate(item.url);
                                    }, className: "flex items-center rounded\n                  ".concat(!item.url
                                        ? "cursor-default text-gray-500"
                                        : "cursor-pointer", "\n            ").concat(isLast ? "font-semibold text-blue-700" : "text-gray-700 ", "\n          ") }, { children: [item.icon && (_jsx(FontAwesomeIcon, { icon: getFontAwesomeIcon(item.icon), className: "mr-1 text-xs" })), _jsx("span", __assign({ className: "text-lg" }, { children: item.title }))] })), !isLast && (_jsx("span", __assign({ className: "mx-2 text-gray-400 text-xs mt-1" }, { children: _jsx(FontAwesomeIcon, { icon: faChevronRight }) })))] }), index));
                    })) })), _jsx("div", __assign({ className: "h-auto pt-2 pb-4 m-2 font-bold text-sm" }, { children: lastDesc }))] })));
}
widgetsDictionary.register("widget/admin/menu/horizontal", {
    name: "Admin menu horizontal",
    validation: true,
    display: AdminWidgetHorizontal,
});
